import { useWishlistStore } from '~/store/wishlist';
import { useCartStore } from '~/store/cart';

export default defineNuxtPlugin(async (nuxtApp) => {
  const wishlistStore = useWishlistStore(nuxtApp.$pinia as any);
  const cartStore = useCartStore(nuxtApp.$pinia as any);
  
  // Watch for cart initialization and user login changes
  if (import.meta.client) {
    let lastEmail: string | null = null;
    
    watch(
      () => ({
        initialized: cartStore.cartInitialized,
        email: cartStore.cartData?.user?.email
      }),
      async ({ initialized, email }) => {
        // Only load if cart is initialized and user is logged in
        if (initialized && email && email !== lastEmail) {
          lastEmail = email;
          try {
            await wishlistStore.loadWishlist();
          } catch (error) {
            // Silently fail - user might not have wishlist enabled or might not be authenticated
          }
        } else if (!email && lastEmail) {
          // User logged out - clear wishlist
          lastEmail = null;
          wishlistStore.items = [];
        }
      },
      { immediate: true, deep: true }
    );
  }
});

